import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { isEmpty, get, concat } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'
import { TECHNO_CATEGORIES } from '@/utils/constants'

const actions = {
    retrieveItems({ commit, rootState }) {
        //check if techno data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'technology', null)
        if (!dataType) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(os => {
                if (get(os, 'status') === 'KO') {
                    errorHandler('Error while retrieving operating system (OS) data', commit)
                } else if (!isEmpty(os.list)) {
                    const countryCode2 = get(rootState, 'account.country.code2', '')
                    commit('setRetrievedItems', {
                        items: concat(TECHNO_CATEGORIES.os, helpers.parseData(os.list, countryCode2))
                    })
                    commit('setCollection', helpers.instanciateAll(os.list, countryCode2))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
